module.exports = "/_next/static/resources/art-f4ab3bc3264dc0de42b9afc01fa1e5ad.jpg";